(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('AgentCategoryAccessDialogController', AgentCategoryAccessDialogController);

    AgentCategoryAccessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AgentCategoryAccess', 'AgentAccessInfo', 'ServiceCategory'];

    function AgentCategoryAccessDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, AgentCategoryAccess, AgentAccessInfo, ServiceCategory) {
        var vm = this;

        vm.agentCategoryAccess = entity;
        vm.clear = clear;
        vm.save = save;
        vm.agentaccessinfos = AgentAccessInfo.query();
        vm.servicecategories = ServiceCategory.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.agentCategoryAccess.id !== null) {
                AgentCategoryAccess.update(vm.agentCategoryAccess, onSaveSuccess, onSaveError);
            } else {
                AgentCategoryAccess.save(vm.agentCategoryAccess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:agentCategoryAccessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();
